// Coworker face-photo admin client — SPA client for /api/coworkers/:id/face-photo
// (Access Provider Phase 2, Task 10/14). Mirrors the shape/style of
// apps/admin/src/api/accessReaders.ts: every function takes the Auth0 access
// `token` explicitly, threaded last. GET returns binary bytes rather than
// JSON, so it uses `apiBlob` (like admin PDF/QR downloads) instead of
// `apiRequest`, and treats a 404 (no photo uploaded yet) as `null` rather
// than throwing.
import { apiBlob, apiRequest, ApiError } from './client'

export interface UploadFacePhotoResult {
  ok: true
  changed: boolean
}

/** Returns the coworker's face photo as a Blob, or null if none is on file (404). */
export async function getFacePhoto(coworkerId: string, token: string): Promise<Blob | null> {
  try {
    return await apiBlob(`/api/coworkers/${coworkerId}/face-photo`, { token })
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null
    throw err
  }
}

export function uploadFacePhoto(
  coworkerId: string,
  photoBase64: string,
  consent: boolean,
  token: string,
): Promise<UploadFacePhotoResult> {
  return apiRequest<UploadFacePhotoResult>(`/api/coworkers/${coworkerId}/face-photo`, {
    method: 'POST',
    body: { photoBase64, consent },
    token,
  })
}

export function deleteFacePhoto(coworkerId: string, token: string): Promise<{ ok: boolean }> {
  return apiRequest<{ ok: boolean }>(`/api/coworkers/${coworkerId}/face-photo`, {
    method: 'DELETE',
    token,
  })
}
